<div class="po-row analytics-card-host" [class.is-refreshing]="isLoading()">
  <!-- Left Card: PureOriginal Export Stats -->
  <div class="po-card">
    <div class="card-header">
      <h3>PureOriginal Export Stats</h3>
      <div class="granularity-toggle">
        <button [class.active]="exportStatsGranularity() === 'DAY'" (click)="onExportStatsGranularityChange('DAY')">Day</button>
        <button [class.active]="exportStatsGranularity() === 'WEEK'" (click)="onExportStatsGranularityChange('WEEK')">Week</button>
        <button [class.active]="exportStatsGranularity() === 'MONTH'" (click)="onExportStatsGranularityChange('MONTH')">Month</button>
      </div>
    </div>

    <div class="card-body" *ngIf="exportStats">
      <!-- Row 1: Uploaded + Updated -->
      <div class="stats-grid">
        <button type="button" class="stat-tile" [disabled]="!exportStats.uploaded"
                (click)="openActivity('UPLOADED', 'Uploaded Pure Originals', exportStats.uploaded)">
          <span class="stat-value">{{ exportStats.uploaded | number }}</span>
          <span class="stat-label">Uploaded</span>
        </button>
        <button type="button" class="stat-tile" [disabled]="!exportStats.updated"
                (click)="openActivity('UPDATED', 'Updated Pure Originals', exportStats.updated)">
          <span class="stat-value">{{ exportStats.updated | number }}</span>
          <span class="stat-label">Updated</span>
        </button>
      </div>

      <!-- Row 2: Exports -->
      <div class="stats-grid" style="margin-top: 12px;">
        <button type="button" class="stat-tile-3" [disabled]="!exportStats.exportedMainDatabase"
                (click)="openActivity('MAIN_DATABASE', 'Main DB Export', exportStats.exportedMainDatabase)">
          <span class="stat-value export-value">{{ exportStats.exportedMainDatabase | number }}</span>
          <span class="stat-label">Main DB Export</span>
        </button>
        <button type="button" class="stat-tile-3" [disabled]="!exportStats.exportedWinOls5Database"
                (click)="openActivity('WIN_OLS5_DATABASE', 'WinOLS5 Export', exportStats.exportedWinOls5Database)">
          <span class="stat-value export-value">{{ exportStats.exportedWinOls5Database | number }}</span>
          <span class="stat-label">WinOLS5 Export</span>
        </button>
        <button type="button" class="stat-tile-3" [disabled]="!exportStats.exportedReseller"
                (click)="openActivity('RESELLER_DATABASE', 'Reseller Export', exportStats.exportedReseller)">
          <span class="stat-value export-value">{{ exportStats.exportedReseller | number }}</span>
          <span class="stat-label">Reseller Export</span>
        </button>
      </div>
    </div>

    <div class="card-body empty-state" *ngIf="!isLoading() && !exportStats">
      <span class="empty-text">No export data available</span>
    </div>
  </div>

  <!-- Right Card: Popular Tunings by ECU -->
  <div class="po-card">
    <div class="card-header">
      <h3>Popular Tunings by ECU</h3>
      <span class="badge">Stage 1 only</span>
    </div>

    <div class="card-body">
      <table class="tuning-table" *ngIf="topStage1.length > 0">
        <thead>
          <tr>
            <th>ECU Build</th>
            <th>Tuning</th>
            <th class="text-right">Count</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of topStage1">
            <td class="ecu-build">{{ item.ecuBuild }}</td>
            <td>
              <span class="tuning-badge">
                <span class="green-dot"></span>
                Stage 1
              </span>
            </td>
            <td class="text-right count-value">{{ item.countRequest | number }}</td>
          </tr>
        </tbody>
      </table>

      <div class="empty-state" *ngIf="!isLoading() && topStage1.length === 0">
        <span class="empty-text">No tuning data available</span>
      </div>
    </div>
  </div>
</div>

<dialog #activityDialog class="activity-dialog" (close)="onActivityClosed()" aria-labelledby="activity-title">
  <div class="activity-heading">
    <div>
      <p class="activity-eyebrow">PureOriginal activity</p>
      <h2 id="activity-title">{{ activityTitle() }}</h2>
      <p class="activity-range">{{ activityRangeLabel() }}</p>
    </div>
    <button type="button" class="activity-close" (click)="closeActivity()" aria-label="Close activity list" title="Close">×</button>
  </div>

  <p *ngIf="activityLoading()" class="activity-state" role="status">Loading Pure Originals…</p>
  <div *ngIf="activityError()" class="activity-state" role="alert">
    Could not load Pure Originals. <button type="button" class="activity-retry" (click)="retryActivity()">Try again</button>
  </div>

  <ng-container *ngIf="activityPage() as page">
    <p class="activity-count">{{ page.totalElements | number }} files</p>
    <div class="activity-scroll" *ngIf="page.content.length; else noActivity">
      <table class="activity-table">
        <thead><tr><th>ID</th><th>WinOLS reference</th><th>WinOLS DB name</th><th>Activity time</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let row of page.content" tabindex="0" role="button"
              [attr.aria-label]="'Open Pure Original ' + row.pureOriginalId"
              (click)="openActivityDetails(row)"
              (keydown.enter)="openActivityDetails(row)"
              (keydown.space)="$event.preventDefault(); openActivityDetails(row)">
            <td>{{ row.pureOriginalId }}</td>
            <td [title]="row.winOlsReference || ''">{{ row.winOlsReference || '—' }}</td>
            <td [title]="row.winOlsDbName || ''">{{ row.winOlsDbName || '—' }}</td>
            <td>{{ formatActivityDate(row.dateTime) }}</td>
            <td class="activity-arrow" aria-hidden="true">↗</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #noActivity><p class="activity-state">No Pure Originals in this period.</p></ng-template>
    <nav class="activity-pagination" *ngIf="page.totalPages > 1" aria-label="Pure Original activity pages">
      <button type="button" (click)="goToActivityPage(activityPageNumber() - 1)" [disabled]="activityPageNumber() === 0">Previous</button>
      <span>Page {{ activityPageNumber() + 1 }} of {{ page.totalPages }}</span>
      <button type="button" (click)="goToActivityPage(activityPageNumber() + 1)" [disabled]="page.last">Next</button>
    </nav>
  </ng-container>
</dialog>
